import store from '../store/index.js'

function VerifyToken (to, from, next)
{
    /*let jwt  = sessionStorage.getItem("token")
    let user = JSON.parse( sessionStorage.getItem("user") )
    let menu = JSON.parse( sessionStorage.getItem("menu") ) || []
    store.modules.system.state.user  = user
    store.modules.system.state.token = jwt
    store.modules.system.state.menu  = menu

    if(!sessionStorage.getItem("token")) return next()
    else if (user.login == 'root@root.com') return next('/sumarios')
    else return next('/documentacao')*/

    return ( !sessionStorage.getItem("token") ) ? next() : next("/home")
}
export default VerifyToken



// WEBPACK FOOTER //
// ./src/helpers/VerifyToken.js